// extracted by mini-css-extract-plugin
export default {"noResultsContainer":"NoResults__noResultsContainer--TKsfd","reset":"NoResults__reset--nZaTg"};